import type { Questionnaire } from "@medplum/fhirtypes";
import { readQuestionnaireDefinitionRow } from "../fhir/questionnaire-definition-storage";
import type { QuestionnaireDefinitionDto } from "./questionnaire-definition";

/**
 * Row → DTO. The storage reader throws on an unreadable row rather than
 * substituting, and `deriveQuestionnaireFields` already ran the same read at
 * sync time, so a row reaching this inside a live query is one that reads.
 *
 * The stored shape IS the read model here: a questionnaire definition carries
 * nothing the authoring surface does not show, so there is nothing to narrow.
 */
export function projectQuestionnaireDefinitionRow(resource: Questionnaire): QuestionnaireDefinitionDto {
  return readQuestionnaireDefinitionRow(resource);
}
